import CircularLogo from './CircularLogo';

export default CircularLogo;
